import React from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface IProps {
  title: string;
  href: string;
}

export const BlockTestInfoSection = ({ title, href }: IProps) => {
  const t = useTranslations();

  return (
    <div className="max-w-139 mx-auto flex items-center justify-between rounded-2xl bg-green-500 px-3 py-2">
      <p className="font-medium text-sm sm:text-base text-white">{title}</p>
      <Link
        href={href}
        className="flex h-9 px-2 items-center text-sm sm:text-base justify-center rounded-xl bg-white font-medium text-gray-800"
      >
        {t('korish')}
      </Link>
    </div>
  );
};
